/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import Accordion from '../../Components/AccordionLight';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class Profile05 extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>
        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="content-inner">
                <div className="profile-format-content">
                  <img alt="Research" src={require('./science01.jpg')} />
                  <div>
                    <h1>Dr Kevin Cheung</h1>
                    <p>Principal Research Manager</p>
                  </div>
                </div>
                <p>
                  Dr Kevin Cheung has worked for Cambridge Assessment since 2015 and is now a
                  Principal Research Manager. Prior to joining Cambridge English, he lectured in
                  Social Psychology and Research Methods at Loughborough University, Birmingham City
                  University and the University of Derby, as well as working for the Probation
                  Service. He is a Chartered Psychologist with research specialisms in academic
                  writing, scale development and assessment. He holds a PhD in Psychology and is an
                  Associate Fellow of the British Psychological Society.
                </p>
                <div className="profile__section">
                  <Accordion>
                    <div label="Describe your role and involvement in Linguaskill.">
                      <h3>Describe your role and involvement in Linguaskill.</h3>
                      <p>
                        I oversee research on writing across all Cambridge English products. I
                        became involved in Linguaskill in November 2017 and I am currently working
                        on the product’s Writing component.
                      </p>
                    </div>
                    <div label="What were the needs you were looking to solve with Linguaskill?">
                      <h3>What were the needs you were looking to solve with Linguaskill?</h3>
                      <p>
                        Many language proficiency tests do not include a written component because
                        it is logistically challenging to mark. Many tests consequently rely solely
                        on multiple-choice questions that focus on reading and grammar. However,
                        writing is one of the most important skills that employers and education
                        institutions are interested in. Linguaskill therefore offers an option to
                        include writing, without compromising on cost, efficiency and speed of
                        results delivery. This means that writing skills can be included when they
                        previously wouldn’t have been.
                      </p>
                    </div>
                    <div label="What makes Linguaskill different from other tests?">
                      <h3>What makes Linguaskill different from other tests?</h3>
                      <p>
                        The fact that the writing automarker uses machine learning research from the
                        University of Cambridge to deliver instantaneous results. Because of the
                        collaboration between researchers at ALTA, Cambridge English and Cambridge
                        University Press, we have a unique automarker tailored to the context of
                        English for speakers of other languages (ESOL) exams. These have allowed
                        development of the writing automarker to use the Cambridge Learner Corpus, a
                        collection of genuine exam scripts submitted by ESOL test takers. ALTA’s
                        research uses novel techniques and this means that the technology we have is
                        cutting edge.
                      </p>
                    </div>
                    <div label="What have you learned when developing Linguaskill?">
                      <h3>What have you learned when developing Linguaskill?</h3>
                      <p>
                        That some people are resistant to the idea of a computer marking their
                        writing, even if you present evidence that it performs as well as (if not
                        better than) human examiners. It is therefore part of my job to present
                        evidence that demonstrates this to stakeholders, in a way that is easy for
                        them to understand.
                      </p>
                    </div>
                    <div label="Now that Linguaskill is in the market, what are you most satisfied with in terms of the product and market adoption?">
                      <h3>
                        Now that Linguaskill is in the market, what are you most satisfied with in
                        terms of the product and market adoption?
                      </h3>
                      <p>
                        The enthusiasm that we have had from centres about a test that is quick,
                        efficient and easy to use. It is great to see stakeholders responding
                        positively to improvements in user experience (UX) and ease of use – this
                        makes the testing and development of the platform feel worthwhile.
                      </p>
                    </div>
                    <div label="How do you see Linguaskill developing over the next 2–3 years?">
                      <h3>How do you see Linguaskill developing over the next 2–3 years?</h3>
                      <p>
                        It will possess greater adaptivity so that it offers a more personalised and
                        targeted testing experience, linked to the test taker’s level. Additionally,
                        it will provide more feedback on performance for candidates and
                        institutions.
                      </p>
                    </div>
                    <div label="How do you see computer-based testing changing in the future, particularly with the use of AI?">
                      <h3>
                        How do you see computer-based testing changing in the future, particularly
                        with the use of AI?
                      </h3>
                      <p>
                        More widespread use of AI will make our tests quicker and more resistant to
                        attempted subversion of the results.
                      </p>
                    </div>
                    <div label="Are there other key trends that you see impacting language learning and testing over the next five years?">
                      <h3>
                        Are there other key trends that you see impacting language learning and
                        testing over the next five years?
                      </h3>
                      <p>
                        I see more personalised learning experiences being made possible through
                        more granular assessment information. Being able to link test-taker data
                        together will help us tailor support across the learning journey and manage
                        expectations around progression. Knowing more about how particular groups of
                        test takers improve their language proficiency will also allow us to advise
                        on the best way to progress in specific circumstances. Finally, there will
                        be more assessment happening outside of the exam hall, facilitated by mobile
                        and wearable devices.
                      </p>
                    </div>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default Profile05;
